/* eslint-disable @typescript-eslint/naming-convention */
import React, { useState, useEffect } from 'react';
import { IconButton, InputLabel } from '@mui/material';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import WeeklyLogModalParent from './WeeklyLogModalParent';
import { TextInputField } from '../../../components/inputs';
import { FlexBox } from '../../../components/tableItems';
import { MainButton } from '../../../components/buttons';
import { onlyNumbers } from '../../../helpers/validateInputs';
import useWeeklyLogStore from '../../../stores/weeklyLog/WeeklyLogStore';

interface WeeklyLogSingleFormProps {
  borderColor: string;
  disabled: boolean;
  title: string;
  day: string;
  index: number;
}

const WeeklyLogSingleForm: React.FC<WeeklyLogSingleFormProps> = ({
  borderColor,
  disabled,
  title,
  day,
  index,
}) => {
  const { formWeeklyLog, updateFormWeeklyLog } = useWeeklyLogStore();
  const [value, setValue] = useState('0');
  const [formModal, setFormModal] = useState(false);
  const openFormModal = () => setFormModal(true);
  const closeFormModal = () => setFormModal(false);

  useEffect(() => {
    if (formModal) {
      const { follow_ups, responses_sent } = formWeeklyLog[index];
      const newValue =
        title === 'Follow Ups'
          ? `${follow_ups === null ? '0' : follow_ups}`
          : `${responses_sent === null ? '0' : responses_sent}`;
      setValue(newValue);
    }
  }, [formModal]);

  const onSave = () => {
    if (title === 'Follow Ups')
      updateFormWeeklyLog(index, { follow_ups: parseInt(value, 10) });
    else updateFormWeeklyLog(index, { responses_sent: parseInt(value, 10) });

    closeFormModal();
  };

  return (
    <>
      <IconButton
        aria-label="filter"
        id="long-button"
        sx={{
          border: 1,
          borderRadius: '10%',
          borderColor,
        }}
        aria-haspopup="true"
        onClick={openFormModal}
        disabled={disabled}
        size="small"
      >
        <ModeEditIcon
          sx={{
            fontSize: 14,
            color: borderColor,
          }}
        />
      </IconButton>
      <WeeklyLogModalParent
        title={day}
        closeModal={closeFormModal}
        open={formModal}
        width={350}
      >
        <InputLabel
          htmlFor={title}
          sx={{
            fontSize: 12,
            fontWeight: '700',
            color: 'rgba(0, 0, 0, 0.8)',
            marginBottom: 1,
          }}
        >
          {title}
        </InputLabel>
        <TextInputField
          value={value}
          name={title}
          disabled={false}
          error={value === ''}
          size="small"
          onChange={e => setValue(onlyNumbers(e.target.value))}
          fullWidth
          type="text"
          placeholder={title}
          id={title.toLowerCase()}
        />
        <FlexBox justifyContent="end" mt={2}>
          <MainButton
            loading={false}
            variant="contained"
            sx={{
              background: '#BAF372',
              fontSize: 12,
              color: 'black',
              '&:hover': {
                backgroundColor: '#BAF372',
              },
            }}
            disabled={value === ''}
            onClick={onSave}
          >
            Save
          </MainButton>
        </FlexBox>
      </WeeklyLogModalParent>
    </>
  );
};

export default WeeklyLogSingleForm;
